export interface PriceData {
    inclTaxPrice?: number;
    exclTaxPrice?: number;
}

export enum PriceType {
    IncludeTax = 'IncludeTax',
    ExcludeTax = 'ExcludeTax',
}
